import React from 'react';
import Slider from 'react-slick';
import { ServicListAR } from './serviceData.js'; // Import your service data
import { ServicListEN } from './serviceData.js'; // Import your service data
import ServiceCard from './serviceCard'; // Import your ServiceCard component
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { 
    FaArrowLeft,
    FaArrowRight,
   } from 'react-icons/fa'; // Import the left arrow icon
   import { useLanguage } from '../context/LanguageContext';

// Custom Previous Arrow Component

const CustomPrevArrow = (props) => {
  const { t, language} = useLanguage();
    const { onClick } = props;
    return (
      <div
        className="custom-arrow custom-prev-arrow"
        onClick={onClick}
        style={{left:language==="en"&&"85%",direction:language=="en"&&"ltr"}}
      >
        <FaArrowLeft/>
      </div>
    );
  };

// Custom Next Arrow Component
const CustomNextArrow = (props) => {
  const { t, language} = useLanguage();
    const { onClick } = props;
    return (
      <div
        className="custom-arrow custom-next-arrow"
        onClick={onClick}
        style={{left:language==="en"&&"75%",direction:language=="en"&&"ltr"}}
      >
        <FaArrowRight/>
      </div>
    );
  };

const ServiceSlider = () => {
  const { t, language} = useLanguage();
  const ServicList=language==="en"?ServicListEN:ServicListAR
  // Slider settings
  const settings = {
    dots: true, // Show dots
    infinite: true, // Infinite loop
    speed: 500, // Transition speed
    slidesToShow: 1, // Number of slides to show at once
    slidesToScroll: 1, // Number of slides to scroll
    // arrows: false,
    autoplay: true, // Auto-play the slider
    autoplaySpeed: 3000, // Auto-play speed
    prevArrow: <CustomPrevArrow />, // Custom previous arrow
    nextArrow: <CustomNextArrow />, // Custom next arrow
    responsive: [
      {
        breakpoint: 768,  // Mobile breakpoint (adjust as needed)
        settings: {
          
          dots: false,      // Keep dots for mobile if needed
        },
      },
    ],
  };

  return (
    <div className="slider-container">
      <Slider {...settings}>
      {ServicList.map((service) => {
 
  return (
    <div key={service.id}>
      <ServiceCard data={service} />
    </div>
  );
})}
      </Slider>
    </div>
  );
};

export default ServiceSlider;